module.exports = __webpack_public_path__ + "7f893e37687a5467ad67c477142605da.pdf";